if (!customElements.get('rf-ru-tariffs')) {
  customElements.define('rf-ru-tariffs', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.addEventListener('change', (event) => {
        if (!event.target.matches('input[type="radio"][name="id"]')) return;
        document.querySelectorAll('rf-ru-tariffs').forEach((selector) => {
          if (selector.dataset.productId === this.dataset.productId) {
            selector.selectVariant(event.target.value);
          }
        });
      }, options);
      this.querySelector('form').addEventListener('submit', (event) => {
        const selected = this.querySelector('input[name="id"]:checked');
        if (!selected || selected.dataset.available !== 'true' || this.submitting) {
          event.preventDefault();
          return;
        }
        this.submitting = true;
        this.querySelector('button[type="submit"]').setAttribute('aria-busy', 'true');
      }, options);
      window.addEventListener('pageshow', () => {
        this.submitting = false;
        this.querySelector('button[type="submit"]').removeAttribute('aria-busy');
      }, options);
      const selected = this.querySelector('input[name="id"]:checked') || this.querySelector('input[name="id"]');
      this.selectVariant(selected?.value);
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    selectVariant(variantId) {
      let selected;
      this.querySelectorAll('input[name="id"]').forEach((radio) => {
        radio.checked = radio.value === variantId;
        radio.closest('.rft__tier').classList.toggle('is-selected', radio.checked);
        if (radio.checked) selected = radio;
      });
      const available = selected?.dataset.available === 'true';
      this.querySelector('button[type="submit"]').disabled = !available;
      this.querySelector('.rft__status').textContent = available ? '' : 'Этот тариф пока недоступен.';
    }
  });
}
